<template>
    <div class="page-table  only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp delay-1s">Galeri Listesi</div>
        <!--</div>-->
        <!--<div class="col-6">-->
        <!--<h3>Transition</h3>-->
        <!--<draggable-->
        <!--class="list-group"-->
        <!--v-model="galeriList"-->
        <!--v-bind="dragOptions"-->
        <!--@start="isDragging = true"-->
        <!--@end="isDragging = false">-->
        <!--<transition-group type="transition" name="flip-list">-->
        <!--<li-->
        <!--class="list-group-item"-->
        <!--v-for="(element,index) in galeriList"-->
        <!--:key="element.order">-->
        <!--<img :src="element.url" alt="" class="el-upload-list__item-thumbnail ">-->
        <!--<i :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin' "-->
        <!--@click="element.fixed = !element.fixed"-->
        <!--aria-hidden="true"></i>-->
        <!--{{ element.name }}-->
        <!--</li>-->
        <!--</transition-group>-->
        <!--</draggable>-->
        <!--</div>-->
        <div class="drag animated fadeInUp delay-1s">
            <ul class="el-upload-list el-upload-list--picture-card">
                <draggable
                        id="drag"
                        class="list-group"
                        v-model="galeriList"
                        v-bind="dragOptions"
                        @start="isDragging = true"
                        @end="isDragging = false">
                    <transition-group type="transition" name="flip-list">
                        <li class="el-upload-list__item is-success animated"
                            v-for="(element, index) in galeriList"
                            :key="element.order">
                            <!--<div slot="file" slot-scope="{file}">-->
                            <img :src="element.url" alt="" class="el-upload-list__item-thumbnail">
                            <a class="el-upload-list__item-name">
                                <i class="el-icon-document"></i>
                                @{{element.name}}
                            </a>
                            <label class="el-upload-list__item-status-label">
                                <i class="el-icon-upload-success el-icon-check"></i>
                            </label>
                            <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview"
                                          @click="handlePictureCardPreview(element)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <!--<span class="el-upload-list__item-delete">-->
                                        <!--<i class="mdi mdi-backburger" @click="firstImage(element)"></i>-->
                                    <!--</span>-->
                                    <span class="el-upload-list__item-delete">
                                        <i class="el-icon-delete"
                                           @click="deleteDialogVisible = true; selection=element"></i>
                                    </span>
                                </span>
                            <!--</div>-->
                        </li>
                    </transition-group>
                </draggable>
            </ul>
        </div>
        <el-dialog
                :title='$t("src.views.apps.sayfa.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.name}}' {{$t('src.views.apps.galeri.liste.sil')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="resimRemove(selection), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

    </div>
</template>

<script>

    import JQuery from 'jquery';

    let $ = JQuery;
    import galeriService from '../../../WSProvider/GaleriService'
    import notification from '../../../notification'
    import draggable from 'vuedraggable'

    const message = [
        "vue.draggable",
        "draggable",
        "component",
        "for",
        "vue.js 2.0",
        "based",
        "on",
        "Sortablejs"
    ];

    let base64 = require('base64_js');
    let userDataYilmazlar = "";
    export default {
        name: "GaleriListe",
        display: "Transition",
        order: 6,
        components: {
            draggable
        },
        mounted() {
            this.getGaleriListesi();
        },
        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        data() {
            return {
                list: message.map((name, index) => {
                    return {name, order: index + 1};
                }),

                dialogImageUrl: '',
                dialogVisible: false,
                deleteDialogVisible: false,
                page: 0,
                sizes: 10,
                postPage: '',
                total: null,
                selection: '',
                selectionIndex: '',
                galeriList: [],
                sektorListe: [],
                galeriForm: {
                    sektor: ''
                },
                rulesGaleri: {
                    sektor: [{
                        required: true,
                        message: "Lütfen Sektör Seçiniz",
                        trigger: 'blur'
                    }]
                },

            }
        },
        // watch: {
        //     galeriList: function (val) {
        //         setTimeout(function () {
        //
        //             console.log(val)
        //             var elements = document.querySelector("#drag li")
        //             console.log(elements)
        //             $("#drag li").removeClass("firstImage");
        //             $("#drag li:first-child").addClass("firstImage")
        //         },10)
        //     },
        // },
        methods: {
            sort() {
                this.list = this.list.sort((a, b) => a.order - b.order);
            },
            firstImage(item) {
                var index = this.galeriList.indexOf(item);
                this.galeriList.splice(index, 1);
                this.galeriList.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            resimRemove(file) {
                // console.log(file);
                galeriService.galeriKaldir(file.turKodu).then((response) => {
                    if (response.status === 200) {
                        this.galeriList.splice(this.galeriList.indexOf(file), 1);
                        notification.Status('success', this, "Resim başarıyla kaldırıldı.");
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            getGaleriListesi() {
                var dizi = [];
                galeriService.galeriList().then((response) => {
                    if (response.status === 200) {
                        for (var i = 0; i < response.data.length; i++) {
                            var item = {
                                order: i,
                                turKodu: response.data[i].turKodu,
                                name: response.data[i].baslik,
                                url: galeriService.imageUrlBuyuk + response.data[i].baslik
                            };
                            dizi.push(item);
                        }
                        this.galeriList = dizi;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            }
        }
    }
</script>


<style lang="scss" scoped>
    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px;
        margin-top: 10px;
    }

    .firstImage {
        border: 10px solid #13ce66;
    }

    .el-pagination {
        margin-top: 20px;
        float: right;
    }


    .button {
        margin-top: 35px;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }

    .no-move {
        transition: transform 0s;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .list-group {
        min-height: 20px;
    }

    .list-group-item {
        cursor: move;
    }

    .list-group-item i {
        cursor: pointer;
    }

</style>